<template>
  <div id="compilation">
    <Trip :userGesture="userGesture"/>
    <Popup v-if="popUp" :track="currentKey" :isMobile="isMobile"/>
    <div class="circle-container" :class="{ mobile : isMobile }">
      <div id="menuspace"></div>
      <div
        class="tracklinks"
        v-for="(track, key) in compilationTracks"
        :key="key"
        v-show="userGesture"
        v-on:click="showPopup(track.id, track.trip_x, track.trip_y)"
        v-on:mouseenter="fadeInSound(track.id)"
        v-on:mouseleave="fadeOutSound(track.id, false)"
      >
        <trackItem
          :currentKey="currentKey"
          :track="track"
          :userGesture="userGesture"
          :popUp="popUp"
          :isActive="isActive"
          :isMobile="isMobile"
        />
        <audio :id="'audio' + track.id" :nr="track.id" preload="none">
          <source
            :src="'https://traumgarten.dev0ted.tech/' + track.track_preview.url"
            type="audio/mpeg"
          />
        </audio>
      </div>
    </div>

    <div v-if="!userGesture" id="start" v-on:click="$emit('userGesture')">
        <vue-markdown id="title" :class="{ mobile : isMobile }">{{ startPoem.Title }}</vue-markdown>
        <div id="poembody" :class="{ mobile : isMobile }">
          <vue-markdown>{{ startPoem.text }}</vue-markdown>
          <div id="enter" :class="{ mobile : isMobile }"><p >enter the garden</p></div>
        </div>
      </div>
  </div>
</template>

<script>
import trackItem from "@/components/trackItem.vue";
import Trip from "@/components/Trip.vue";
import VueMarkdown from "vue-markdown";
import axios from "axios";
import EventBus from "../Event";
import Popup from "@/components/Popup.vue";

export default {
  name: "Compilation",
  components: {
    trackItem,
    Trip,
    VueMarkdown,
    Popup
  },
  props: ["compilationTracks", "userGesture", "isMobile"],
  data() {
    return {
      isActive: false,
      noiseStarted: false,
      browser: null,
      startPoem: null,
      currentKey: null,
      popUp: false,
      cancelVolumeSlide: null
    };
  },
  mounted() {
    let VueThis = this;
    EventBus.$on("changeLocation", function(id) {
      VueThis.currentKey = id;
    });
    EventBus.$on("exitPopUp", function() {
      VueThis.closePopup();
    });
  },
  created() {
    let selfobject = this;
    axios
      .get("https://traumgarten.dev0ted.tech/start-poem")
      .then(function(response) {
        selfobject.startPoem = response["data"];
      });
  },
  methods: {
    closePopup() {
      let audio = document.getElementById('audio' + this.currentKey);
      audio.style.visibility = "hidden";
      this.popUp = false;
    },
    showPopup(id, trackx, tracky) {
      // window.console.log("popup");
      this.isActive = true
      let audio = document.getElementById('audio' + id);
      let stone = document.getElementById(id);
      stone.classList.add("playing");
      if (!this.popUp) {
      // window.console.log(trackX, trackY);
      EventBus.$emit("changeLocation", [trackx, tracky]);
      EventBus.$emit("enterPopUp", id);
      this.popUp = true;
      this.currentKey = id;
      audio.style.visibility = "visible";

      if (this.browser != "safari") {
        let playPromise = audio.play();
        if (playPromise !== undefined) {
          playPromise
            .then(reponse => {
              window.console.log(reponse);
              // playback started
            })
            .catch(error => {
              window.console.log(error);
              // Auto-play was prevented
              // Show paused UI.
            });
        }
      }
      } else {
        EventBus.$emit("exitPopUp");
      }
    },
    fadeInSound(id) {
      // window.console.log("fade in");
      this.cancelVolumeSlide = true;
      this.isActive = true;
      this.currentKey == id;
      if (this.currentKey == id && this.popUp == true) {
        let audio = document.getElementById('audio' + id);
        let stone = document.getElementById(id);
        let playPromise = audio.play();
        audio.volume = 1.0;
        // audio.currentTime = 0;
        stone.classList.add("playing");
        this.cancelVolumeSlide = false;

        if (playPromise !== undefined) {
          playPromise
            .then(reponse => {
              window.console.log(reponse);
              // playback started
            })
            .catch(error => {
              window.console.log(error);
              // Auto-play was prevented
              // Show paused UI.
            });
        }
      }
    },
    fadeOutSound(id) {
      // window.console.log("fade out");
      let audio = document.getElementById('audio' + id);
      let stone = document.getElementById(id);
      stone.classList.remove("playing");
        this.isActive = false;
            audio.pause();
            audio.volume = 1;
            // audio.currentTime = 0;
    }
  }
};
</script>

<style lang='scss'>
.circle-container {
  position: absolute;
  top: 4%;
  left:4%;
  width: 88%;
  height: 92%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content:space-around;
  align-items:center;
  pointer-events: none;
}

.circle-container > div {
  font-family: "tg";
  font-size: 1.5vw;
  text-transform: lowercase;
  font-family: "tg";
  text-align: center;
  align-self: center;
  pointer-events: initial;
}

#compilation > img {
  height: 80%;
  width: auto;
  display: block;
  top: 0;
  margin: 6vh auto 0;
}

#compilation {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  box-sizing:border-box;
}

#menuspace {
  width: 13.8vw;
  height: 17vw;
}

#start {
  color: rgb(42, 184, 26);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 500;
  display:flex;
  flex-direction:column;
  margin:0;
  padding:0;
  background-color: #283441;
  cursor: pointer;
  overflow:hidden;
}


.circle-container.mobile{
   flex-wrap:nowrap;
   height:initial;
   top:0px;
   overflow:auto;
   padding:25vh 0 15vh 0;
  -webkit-overflow-scrolling: touch;
}


#poembody {
  position:relative;
  width:100%;
  // height:100%;
  top:0;
  padding:0 5% 0 5%;
  font-family: tg;
  font-size: 1.6vw;
  text-align: center;
  white-space: normal;
  overflow:auto;
  -webkit-overflow-scrolling: touch;
}

#poembody p {
    margin-block-start:3vw;
}

#poembody.mobile {
  font-size:2.5vh;
}

#title {
    width:100%;
    position:relative;
    z-index:1000;
}

#title.mobile p {
  font-size:6.5vh;
}

#title p {
  font-family: flowers;
  font-size: 10vh;
  font-weight: 400;
  text-align: center;
  white-space: normal;
  margin-block-start:3vh;
  margin-block-end:5vh;
}


#enter {
  position:relative;
  font-family: flowers;
  font-size: 10vh;
  font-weight: 400;
  text-align: center;
  white-space: normal;
  height:80vh;
  animation: textglow 8s infinite;
}

#enter p {
  margin: 0;
  position: absolute;
  width:100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

#enter.mobile {
  font-size:6.5vh;
}

audio {
  width: 40%;
  position: absolute;
  left: 30%;
  top: 5%;
  height: 10vh;
  visibility: hidden;
}


a, a:hover, a:visited {
  color:rgb(61, 102, 85);
}

.vibrate-1 {
  -webkit-animation: vibrate-1 30s ease-in-out infinite both;
  animation: vibrate-1 30s ease-in-out infinite both;
}

.fadeout {
  -webkit-animation: fadeout 0.5s ease both;
  animation: fadeout 0.5s ease both;
}

.fadein {
  -webkit-animation: fadein 0.5s ease both;
  animation: fadein 0.5s ease both;
}

@-webkit-keyframes fadein {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  100% {
    -webkit-transform: translateX(-50px);
    transform: translateX(-50px);
  }
}
@keyframes fadein {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  100% {
    -webkit-transform: translateX(-50px);
    transform: translateX(-50px);
  }
}

@-webkit-keyframes fadeout {
  0% {
    -webkit-transform: translateX(-50px);
    transform: translateX(-50px);
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}
@keyframes fadeout {
  0% {
    -webkit-transform: translateX(-50px);
    transform: translateX(-50px);
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}

@-webkit-keyframes vibrate-1 {
  0% {
    -webkit-transform: translate(0px, 10px);
    transform: translate(0px, 10px);
  }
  30% {
    -webkit-transform: translate(5px, -10px);
    transform: translate(5px, -10px);
  }
  60% {
    -webkit-transform: translate(0px, 10px);
    transform: translate(0px, 10px);
  }
  80% {
    -webkit-transform: translate(-5px, -10px);
    transform: translate(-5px, -10px);
  }
  100% {
    -webkit-transform: translate(0px, 10px);
    transform: translate(0px, 10px);
  }
}
@keyframes vibrate-1 {
  0% {
    -webkit-transform: translate(0px, 10px);
    transform: translate(0px, 10px);
  }
  30% {
    -webkit-transform: translate(5px, -10px);
    transform: translate(5px, -10px);
  }
  60% {
    -webkit-transform: translate(0px, 10px);
    transform: translate(0px, 10px);
  }
  80% {
    -webkit-transform: translate(-5px, -10px);
    transform: translate(-5px, -10px);
  }
  100% {
    -webkit-transform: translate(0px, 10px);
    transform: translate(0px, 10px);
  }
}


.playing img {
    animation: playing 5s infinite;
}


@keyframes playing {
  0% {
  filter: invert(42%) sepia(93%) saturate(30%) hue-rotate(120deg) brightness(20%) contrast(119%);
  }
  50% {
  filter: invert(42%) sepia(93%) saturate(50%) hue-rotate(0deg) brightness(200%) contrast(0%);
  }
  100% {
    filter: invert(42%) sepia(93%) saturate(30%) hue-rotate(120deg) brightness(20%) contrast(119%);
  }
}

@keyframes textglow {
  0% {
  color:rgb(42, 184, 26);
  }
  50% {
  color:rgb(114, 61, 163);
  }
  100% {
   color:rgb(42, 184, 26);
  }
}

</style>